'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _htmlToReact = require('html-to-react');

var _htmlToReact2 = _interopRequireDefault(_htmlToReact);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _button = require('../../../atoms/button');

var _button2 = _interopRequireDefault(_button);

var _heading = require('../../../atoms/heading');

var _heading2 = _interopRequireDefault(_heading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var htmlToReactParser = new _htmlToReact2.default.Parser();

// TODO: Change this to building blocks to remove the necessity of declaring
// renderCta, renderPara, etc.

var IconPanel = function (_React$Component) {
  _inherits(IconPanel, _React$Component);

  function IconPanel(props) {
    _classCallCheck(this, IconPanel);

    var _this = _possibleConstructorReturn(this, (IconPanel.__proto__ || Object.getPrototypeOf(IconPanel)).call(this, props));

    _this.enableIcon = function () {
      window.removeEventListener('resize', _this.handleResize);
      window.removeEventListener('scroll', _this.handleScroll);

      _this.setState({ showIcon: true });
    };

    _this.handleResize = function () {
      var domRect = _this.divElement && _this.divElement.getBoundingClientRect();
      if (domRect && window.innerHeight - domRect.top >= 0) {
        _this.enableIcon();
      }
    };

    _this.handleScroll = function () {
      _this.enableIcon();
    };

    _this.renderIcon = function (icon) {
      if (icon && _this.state.showIcon) {
        return _react2.default.createElement('img', { src: icon.src, alt: icon.alt, className: 'icon-panel__image' });
      }
      return null;
    };

    _this.renderHeadline = function (headline) {
      if (headline) {
        return _react2.default.createElement(
          _heading2.default,
          { level: '3', className: 'icon-panel__headline pp-sans-small-regular h4' },
          htmlToReactParser.parse(headline.text)
        );
      }
      return null;
    };

    _this.renderParagraph = function (paragraph) {
      if (paragraph) {
        return _react2.default.createElement(
          'p',
          { className: 'icon-panel__paragraph' },
          htmlToReactParser.parse(paragraph.text)
        );
      }
      return null;
    };

    _this.renderCta = function (cta) {
      if (cta && cta.text) {
        var targetValue = cta.target || '_self';
        return _react2.default.createElement(
          _button2.default,
          {
            id: cta.id,
            href: cta.href,
            className: 'icon-panel__cta',
            fpti: '' + _this.props.name + _this.props.pnlIdx + '-' + cta.type + '-' + cta.text,
            color: cta.color || 'blue',
            target: targetValue
          },
          cta.text
        );
      }
      return null;
    };

    _this.renderHatchText = function (hatchText) {
      if (hatchText && hatchText.text) {
        return _react2.default.createElement(
          'p',
          { className: 'icon-panel__hatch-text' },
          htmlToReactParser.parse(hatchText.text)
        );
      }
      return null;
    };

    _this.state = {
      showIcon: false
    };
    return _this;
  }

  _createClass(IconPanel, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // if components in view, then enable icons; otherwise add listeners
      var domRect = this.divElement && this.divElement.getBoundingClientRect();
      if (domRect && window.innerHeight - domRect.top >= 0) {
        this.enableIcon();
      } else {
        window.addEventListener('scroll', this.handleScroll);
        window.addEventListener('resize', this.handleResize);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('resize', this.handleResize);
    }

    // once enableIcon() is called, there is no need to listen anymore


    // if after window resize and the component is in view, then enable icons,
    // otherwise do nothing

    /**
      Receives CTA and creates it according to the type.
      Underlying data structure shows the correct order
      semantically.
      TODO: Reuse this across Panels
    */

  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props$content = this.props.content,
          headline = _props$content.headline,
          paragraph = _props$content.paragraph,
          primaryCta = _props$content.primaryCta,
          secondaryCta = _props$content.secondaryCta,
          hatchText = _props$content.hatchText,
          icon = _props$content.icon;

      var moleculeClasses = (0, _classnames2.default)('icon-panel', this.props.className);

      return _react2.default.createElement(
        'div',
        {
          className: moleculeClasses,
          ref: function ref(el) {
            _this2.divElement = el;
          }
        },
        _react2.default.createElement(
          'div',
          { className: 'icon-panel__top' },
          this.renderIcon(icon),
          this.renderHeadline(headline),
          this.renderParagraph(paragraph)
        ),
        _react2.default.createElement(
          'div',
          { className: 'icon-panel__bottom' },
          this.renderCta(primaryCta),
          this.renderCta(secondaryCta),
          this.renderHatchText(hatchText)
        )
      );
    }
  }]);

  return IconPanel;
}(_react2.default.Component);

exports.default = IconPanel;


IconPanel.propTypes = {
  /* eslint-disable-next-line react/no-unused-prop-types */
  config: _propTypes2.default.shape({
    type: _propTypes2.default.string
  }),
  content: _propTypes2.default.shape({
    icon: _propTypes2.default.shape({
      src: _propTypes2.default.string.isRequired,
      alt: _propTypes2.default.string
    }), // isVisible
    headline: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }), // isVisible
    paragraph: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }).isRequired,
    primaryCta: _propTypes2.default.shape({
      id: _propTypes2.default.string,
      href: _propTypes2.default.string.isRequired,
      text: _propTypes2.default.string.isRequired,
      type: _propTypes2.default.string,
      color: _propTypes2.default.oneOf(['blue', 'white']),
      target: _propTypes2.default.oneOf(['_self', '_blank'])
    }),
    secondaryCta: _propTypes2.default.shape({
      id: _propTypes2.default.string,
      href: _propTypes2.default.string.isRequired,
      text: _propTypes2.default.string.isRequired,
      type: _propTypes2.default.string,
      color: _propTypes2.default.oneOf(['outline-white', 'outline-blue']),
      target: _propTypes2.default.oneOf(['_self', '_blank'])
    }),
    hatchText: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    })
  }),
  pnlIdx: _propTypes2.default.number,
  name: _propTypes2.default.string,
  className: _propTypes2.default.string
};

IconPanel.defaultProps = {
  config: {
    type: 'IconPanel'
  },
  content: {
    icon: {
      src: 'https://www.paypalobjects.com/digitalassets/c/icons/security_white_72.svg',
      alt: ''
    },
    headline: {
      text: 'Fewer than 44 characters'
    },
    paragraph: {
      text: 'Fewer than 130 characters total for paragraph text which should ' + 'equal less than 4 lines of text, sentence case, normal punctuation.'
    },
    primaryCta: {
      id: '',
      href: '#',
      text: '18 Characters Max',
      type: 'PrmryCTA',
      color: 'white',
      target: '_self'
    },
    secondaryCta: {
      id: '',
      href: '#',
      text: '18 Characters Max',
      type: 'ScndCTA',
      color: 'outline-white',
      target: '_self'
    },
    hatchText: {
      text: 'Fewer than 30 characters total'
    }
  },
  pnlIdx: 0,
  name: 'PanelsPanel',
  className: ''
};


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/molecules/icon-panel/jsx/IconPanel.js
// module id = 564
// module chunks = 4